import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { Fail } from '../../types';
import { RegisterPayload } from './types';

export const registerRequest = action(
  'REGISTER_REQUEST',
  withPayload<RegisterPayload>(),
);

export const registerSuccess = action(
  'REGISTER_SUCCESS',
  withoutPayload,
);

export const registerFail = action(
  'REGISTER_FAIL',
  withPayload<Fail>(),
);

export const resendRequest = action(
  'RESEND_REQUEST',
  withPayload<string>(),
);

export const resendSuccess = action(
  'RESEND_SUCCESS',
  withoutPayload,
);

export const resendFail = action(
  'RESEND_FAIL',
  withPayload<Fail>(),
);
